import React, {useEffect} from 'react';
import {SnackbarProvider, useSnackbar} from 'notistack';
import {useRecoilState} from 'recoil';
import {alertState} from '../../recoil-store/recoil-state';

function SnackBarEnqueue() {
    const [alert, setAlert] = useRecoilState(alertState);
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        if (alert.show) {
            enqueueSnackbar(alert.message, {
                variant: alert.severity
            })
        }
    }, [alert])

    const handleTimeOut = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setAlert(a => ({...a, show: false, message: '', severity: 'info'}))
    };

    return (
        <React.Fragment/>
    )

}


function SnackBarNotification() {
    return (
        <div data-test="component-snackbar">
            <SnackbarProvider maxSnack={3} autoHideDuration={3000} anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}>
                <SnackBarEnqueue/>
            </SnackbarProvider>
        </div>
    );
}


export default SnackBarNotification;


/**
 * OLD SNACKBAR NOTIFICATION STRUCTURE IS COMMENTED BELOW
 */

//
// import React from 'react';
// import Snackbar from '@material-ui/core/Snackbar';
// import MuiAlert from '@material-ui/lab/Alert';
// import { useRecoilState } from 'recoil';
// import { alertState } from '../../recoil-store/recoil-state';
//
// function SnackBarNotification() {
//
//     const [alert, setAlert] = useRecoilState(alertState);
//
//     const handleTimeOut = (event, reason) => {
//         if (reason === 'clickaway') {
//             return;
//         }
//         setAlert(a => ({ ...a, show: false, message: '', severity: 'info' }))
//     };
//
//     return (
//         <div data-test="component-snackbar">
//             <Snackbar
//                 anchorOrigin={{ vertical: "top", horizontal: "center" }}
//                 autoHideDuration={2000}
//                 open={alert.show}
//                 onClose={handleTimeOut}
//             >
//                 <MuiAlert elevation={6}
//                           severity={alert.severity}
//                 >
//                     {alert.message}
//                 </MuiAlert>
//             </Snackbar>
//         </div>
//     );
// }
//
//
// export default SnackBarNotification;

